import { css } from '@emotion/react';

export default $ => css(
  $.overflows.map(value => `
    .overflow-${value} { 
      overflow: ${value} !important; 
    }
  `)
);
